// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as CountryRepoConfig from "./CountryRepoConfig.bs.js";

var dummyCountryInfoIndia = {
    "currency_config": {
        "iso_code": "INR",
        "iso_numeric": "356",
        "name": "Indian Rupee",
        "symbol": "₹"
    },
    "timezone_config": {
        "config": "Asia/Kolkata"
    },
    "mobile_validation_regex_str": "^[6-9]{1}[0-9]{9}$",
    "uae_bd_mobile_validation_regex": "^[6-9]{1}[0-9]{9}$"
  };

function fetchCountryConfig(param) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyCountryInfoIndia
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CountryRepoConfig.CountryResponseConverter.execute, result);
                        });
            });
}

var T = {
  fetchCountryConfig: fetchCountryConfig
};

export {
  T ,
  
}
/* CountryRepoConfig Not a pure module */
